import { RedirectAfterPollForSurveyCommand } from './commands/redirect_after_poll_for_survey_command';
import { PollContainterController } from './components/poll_container/poll_container_controller';
import { ScheduledPollDatastore } from './datastore/scheduled_poll_datastore';
import { PollCapabilityConfiguration } from './poll_configuration';
import { PollRoutes } from './poll_routes';
import { PollQueryModel } from './queries/poll_query_model';
import { PollResultsQueryModel } from './queries/poll_results_query_model';
import { ScheduledPollQuery } from './queries/scheduled_poll_query';
import { CheckScheduledPollsServant } from './servants/check_scheduled_poll_servant';
import { PollPlatformServant } from './servants/poll_platform_servant';
import { PollResultsServant } from './servants/poll_results_servant';

angular.module('capability-ng-poll', [
  'ui-ng-delegate',
  'utility-ng-kernel',
  'utility-ng-enumeration',
  'ngSanitize',
  'ngAria',
  'ui.router'
]);

import './core';

angular
  .module('capability-ng-poll')
  .factory('ngScheduledPollDatastore', (): ScheduledPollDatastore => {
    return new ScheduledPollDatastore().initialize();
  })
  .service('ngScheduledPollQuery', ScheduledPollQuery)

  .service('ngCheckScheduledPollsServant', CheckScheduledPollsServant)
  .service('ngPollResultsServant', PollResultsServant)
  .service('ngPollPlatformServant', PollPlatformServant)
  .service('ngPollCapabilityConfiguration', PollCapabilityConfiguration)
  .service('ngRedirectAfterPollForSurvey', RedirectAfterPollForSurveyCommand)

  .service('ngPollQueryModel', PollQueryModel)
  .service('ngPollResultsQueryModel', PollResultsQueryModel)

  .controller('PollContainterController', PollContainterController)

  .config(PollRoutes);

export * from './types/poll_question_types';

export * from './builders/choice_builder';
export * from './builders/poll_builder';
export * from './builders/question_builder';
export * from './builders/question_x_choice_builder';
export * from './builders/question_x_choice_x_resource_builder';

export * from './commands/load_poll_command';
export * from './commands/load_scheduled_polls_command';
export * from './commands/load_poll_summary';
export * from './commands/update_poll_answer_command';
export * from './commands/update_poll_status_command';
export * from './commands/redirect_after_poll_for_survey_command';

export * from './components/poll_container/poll_container_controller';

export * from './datastore/poll_answer_datastore';
export * from './datastore/poll_datastore';
export * from './datastore/poll_student_datastore';
export * from './datastore/scheduled_poll_datastore';

export * from './queries/poll_query_model';
export * from './queries/poll_results_query_model';
export * from './queries/scheduled_poll_query';

export * from './servants/check_scheduled_poll_servant';
export * from './servants/poll_results_servant';
export * from './servants/poll_platform_servant';

export * from './types/question_types';

export * from './poll_configuration';

export const DNPI = 'capability-ng-poll';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/main.ts